// extracted by mini-css-extract-plugin
export default {"heading":"heading--nwgrT","border":"border--o6pOC","closeButton":"closeButton--QFynQ"};